exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-group > div:first-child .emplacement-tree-selector .ets-field {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n", ""]);

// exports
